import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  SUBJECT_LIST: '/dh-datamaint/expSubject/list',
  PAGE: '/dh-datamaint/experiment/page',
  DELETE: '/dh-datamaint/experiment/batchDelete',
  ADD: '/dh-datamaint/experiment/add',
  UPDATE: '/dh-datamaint/experiment/update',
  BATCH_UPDATE: '/dh-datamaint/experiment/batchUpdate',
  DETAIL: '/dh-datamaint/experiment/getById',
  GET_SORT: '/dh-datamaint/experiment/getSort',
  SORT_EXP: '/dh-datamaint/experiment/sort',
  GET_PREVIEW: '/dh-datamaint/experiment/preview',
  PREVIEW_LANG: '/dh-datamaint/courseware/listCwLang'
};

class ExpModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SUBJECT_LIST, { params: payload.data });
    },

    async getPage(context: ActionContext<any, any>, payload: any) {
      // const res = await ajax.get(URL.PAGE, { params: payload.data });
      const res = await ajax.post(URL.PAGE, payload.data,
        { params: { pageNo: payload.data.pageNo, pageSize: payload.data.pageSize } });
      return res;
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async BatchUpdate(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.BATCH_UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, payload.data);
    },

    async sortExp(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT_EXP, payload.data);
    },

    async getPreview(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_PREVIEW, { params: payload.data });
    },

    async getPreviewLang(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PREVIEW_LANG, { params: payload.data });
    }
  };
}

export const expModule = new ExpModule();
